// @ts-nocheck 73a1fa3d
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_Vmenu'],
      sections: [addPanel.sections.getSections().menu.verticalMenusSection],
    };
  },
};
